<template>
    <v-img src="https://assets.invisee.com/statis/revamp/header-img.jpg"></v-img>
</template>

<script>
    export default {
        data: () => ({

        }),
    }
</script>